import {
    AnalyticsRequest,
    GroupBy,
    Sort,
    Metric,
} from '../../PanelTemplatesTheme/PanelTemplatesTheme';
import { Panel } from 'models/Panel/Panel';
import { WIDGET_LABEL_SIZE } from 'components/Widget/WidgetLabel/constants';
import ListeningDimensions from '@sprinklr/stories-services/AnalyticsService/ListeningDimensions';
import { DefaultPosition } from '../../PanelTemplatesTheme/constants';

export const TemplateHyperSpaceTreeMap: Panel = {
    id: 'hyper-space-tree-map',
    name: 'Tree Map',
    description: '',
    tags: ['Standard', 'Tree Map', 'landscape', 'portrait'],
    widget: {
        id: '1',
        position: {
            width: '1920px',
            height: '1080px',
            top: '0',
            left: '0',
        },
        classes: 'template_tree_map',
        children: [
            {
                type: 'hyperSpaceTreeMap',
                id: 'hyper-space-tree-map',
                name: 'Tree Map - NEW',
                useGlobalTimePeriod: true,
                analyticsRequests: [
                    // Note: All global variables like reportingEngine, report, filters, and projections
                    // are injected via AnalyticsRequest.getRequests()
                    new AnalyticsRequest({
                        limit: 6,
                        projections: [
                            new Metric({
                                STORY_MESSAGE: { dimensionName: 'IMPACT', heading: 'Web_Impact' },
                            }),
                        ],
                        groupBys: [
                            new GroupBy({
                                LISTENING: { source: ListeningDimensions.topicName },
                                INBOUND_MESSAGE: { dimensionName: 'SN_TYPE' },
                                PLATFORM: { dimensionName: 'SN_TYPE' },
                                BENCHMARKING: { dimensionName: 'BENCHMARKING_SN_TYPE' },
                                PAID: { dimensionName: 'adCreativeType' },
                                ADVOCACY: { dimensionName: 'COMMUNITY_USER_ID' },
                                RDB_FIREHOSE: { dimensionName: 'RDB_QUERY_IDS' },
                                STORY_MESSAGE: { dimensionName: 'STORY' },
                                TWITTER: { dimensionName: 'TRENDING_TOPIC' },
                            }),
                        ],
                        sorts: [
                            new Sort({ order: 'DESC', projections: 0 }),
                            new Sort({ order: 'ASC', groupBys: 0 }),
                        ],
                        timePeriods: [{ key: 'last_7_days' }, { previousPeriod: true }],
                    }) as any,
                ],
                position: DefaultPosition,
                label: {
                    titleText: 'Tree Map',
                    size: WIDGET_LABEL_SIZE.primary,
                    enabled: false,
                },
                options: {
                    labelSize: 30,
                    metricGroupOptions: {
                        enabled: true,
                        metric: {
                            size: 35,
                            enabled: true,
                            format: {
                                decimals: 2,
                                useShortened: true,
                            },
                        },
                        metricName: {
                            size: 20,
                            enabled: true,
                        },
                        percentChange: {
                            size: 20,
                            enabled: false,
                        },
                    },
                },
            },
        ],
    },
};
